/**
 * Date-extensions locale Urdu [ur]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ur', {
    monthNames: ['جنوری','فروری','مارچ','اپریل','مئی','جون','جولائی','اگست','ستمبر','اکتوبر','نومبر','دسمبر'],
    monthShortNames: ['جنوری','فروری','مارچ','اپریل','مئی','جون','جولائی','اگست','ستمبر','اکتوبر','نومبر','دسمبر'],
    dayNames: ['اتوار','پیر','منگل','بدھ','جمعرات','جمعہ','ہفتہ'],
    dayShortNames: ['اتوار','پیر','منگل','بدھ','جمعرات','جمعہ','ہفتہ']
});
